import { Button, Checkbox, Modal, ModalBody, ModalContent } from "@nextui-org/react";
import React, { useState } from "react";

function ContactCustomerModal({ isOpen, onClose, user_role }) {
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <Modal className="w-full" size={"md"} isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        {(onClose) => (
          <ModalBody>
            <h1 className="text-center font-semibold text-2xl text-gray-800">
              Contract Info
            </h1>
            <div className="h-[400px] px-2 overflow-y-scroll border border-gray-400 rounded-lg">
              <p className="text-xs mt-2">
                By agreeing to the terms and conditions mentioned in this document, you are bound to follow all the instructions as mentioned below.
              </p>
              {user_role === "SUPPLIER" ? (
                <div className="my-2 py-1">
                  <h2 className="font-semibold text-md my-2 text-gray-700">1. Supplier Agreement</h2>
                  <p className="text-xs">
                    This agreement includes all the terms and conditions that a supplier must follow to use the website smoothly. This document consists of guidelines regarding the services and rules. Suppliers should not engage in any misleading or illegal activities.
                  </p>
                  <h2 className="font-semibold text-md my-2 text-gray-700">2. General Guidelines for Suppliers</h2>
                  <p className="text-xs">
                    Suppliers must provide full, correct, true, and accurate information regarding the products. The supplier is solely responsible for the quality and quantity of the products sold by them. Suppliers must not post any product or information that is misleading to the customer or engage in any illegal activity.
                  </p>
                </div>
              ) : (
                <div className="my-2 py-1">
                  <h2 className="font-semibold text-md my-2 text-gray-700">1. Collection of your info</h2>
                  <p className="text-xs">
                    If you are using this website, you are responsible for maintaining the confidentiality of your account and password, as well as all activities that occur under your account name. You must take all necessary steps to ensure that your password is kept confidential and not shared with anyone.
                  </p>
                </div>
              )}
            </div>
            <div className="mt-1 mb-1">
              <Checkbox required size="sm" color="blue" onChange={handleCheckboxChange}>
                Accept Terms and Conditions
              </Checkbox>
            </div>
            <div className="grid grid-cols-4 gap-2 pb-3">
              <div></div>
              <div></div>
              <Button className="border-2 h-8 border-orange-500 text-orange-500 bg-transparent" onClick={onClose}>
                Cancel
              </Button>
              <Button isDisabled={!isChecked} onClick={onClose} className="border-2 h-8 border-green-500 text-green-500 bg-transparent">
                Next
              </Button>
            </div>
          </ModalBody>
        )}
      </ModalContent>
    </Modal>
  );
}

export default ContactCustomerModal;
